/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('MediaConversionTemplateService',
    function (this: JS5Object, _: JS5Object, MediaConversionTemplateResource: JS5Object) {
        this.getAllMediaConversionTemplates = () => {
            return MediaConversionTemplateResource.getMediaConversionTemplates().$promise
                .then((response: JS5Object) => {
                    return _.filter(response.results, (template: JS5Object) => {
                        return template.converterType !== 'Vantage' || _.startsWith(template.name, 'RE_');
                    });
                });
        };

        this.getTypedMediaConversionTemplates = (templateType: string) => {
            return this.getAllMediaConversionTemplates()
                .then((templates: JS5Object[]) => {
                    return _.filter(templates, (template: JS5Object) => {
                        return template.converterType === templateType;
                    });
                });
        };

        this.getMediaConversionTemplate = (templateId: string) => {
            return MediaConversionTemplateResource.getMediaConversionTemplate({id: templateId}).$promise;
        }

        this.createMediaConversionTemplate = (template: JS5Object) => {
            return MediaConversionTemplateResource.createMediaConversionTemplate(template).$promise;
        }

        this.updateMediaConversionTemplate = (template: JS5Object) => {
            return MediaConversionTemplateResource.updateMediaConversionTemplate(template).$promise;
        }

        this.deleteMediaConversionTemplate = (templateId: string) => {
            return MediaConversionTemplateResource.deleteMediaConversionTemplate({id: templateId}).$promise;
        };
    });
